{
  "mandatoryFields": {
    "part1": "Felder, die mit einem",
    "part2": "gekennzeichnet sind, sind Pflichtfelder"
  },
  "confirm": {
    "leave": {
      "page": {
        "title": "Seite verlassen?",
        "message": {
          "unsavedData": "Es wurden Aktualisierungen vorgenommen und sie werden nicht gespeichert. Möchten Sie die Seite verlassen?"
        }
      }
    },
    "okLabel": "Bestätigen",
    "cancelLabel": "Abbrechen",
    "cancel": {
      "title": "Änderungen abbrechen?",
      "message": "Änderungen wurden vorgenommen und werden nicht gespeichert. Möchten Sie das Abbrechen der Änderungen bestätigen?"
    }
  },
  "noData": "Keine Daten"
}
